import { faLink } from '@fortawesome/pro-light-svg-icons'

import CustomLinks from '@components/CustomLinks'

import useCurrentUser from '@hooks/useCurrentUser'
import useUser from '@hooks/useUser'

export const icon = faLink

export const configOptions = () => {}

const CustomLinksBase = () => {
  const { currentUser } = useCurrentUser()

  const userPayload = useUser(currentUser)
  const {
    callbacks: {
      createOrEditCustomLinks,
      updateUser: updateFn,
    },
    hasQuickLinks,
    loading,
    quickLinks,
  } = userPayload

  return (
    <CustomLinks
      callbacks={{
        createOrEditCustomLinks: () => createOrEditCustomLinks({
          callbacks: {
            updateEntity: updateFn,
          },
        }),
      }}
      hasQuickLinks={hasQuickLinks}
      loading={loading!}
      quickLinks={quickLinks}
    />
  )
}

export default CustomLinksBase
